import angular from "angular";
import SignaturePad from "./SignaturePad.vue";
import Vue from "vue";
import "ngVue";
import VueSignaturePad from "vue-signature-pad";

Vue.use(VueSignaturePad);

export default angular
  .module("directives.signaturepad", [])
  .directive("dsSignaturePad", [
    "createVueComponent",
    function (createVueComponent) {
      return createVueComponent(Vue.component("DsSignaturePad", SignaturePad));
    },
  ]);
